module.exports = "/assets/logo_sg_fresco-77fedd8f30085f1d4e3c9dadb2de9711.png";